export enum DescriptionPages {
  MarkedQuestions = 'MarkedQuestions',
  VideoContent = 'VideoContent',
  PATGenerators = 'PATGenerators',
  FullLengthTests = 'FullLengthTests',
  MiniLengthTests = 'MiniLengthTests',
  PastTestResults = 'PastTestResults',
  Performance = 'Performance',
  Awards = 'Awards',
  Rewards = 'Rewards',
  CaseBasedScenarios = 'CaseBasedScenarios',
  MockExams = 'MockExams',
  InPersonMock = 'InPersonMock',
  CarsPracticeTests = 'CarsPracticeTests',
  CarsPracticePassages = 'CarsPracticePassages',
  DailyCarsPractice = 'DailyCarsPractice',
  ChapterNotes = 'ChapterNotes',
  ResponseTest = 'ResponseTest',
  PracticeResults = 'PracticeResults',
  InfluencerHub = 'InfluencerHub',
}
